module.exports = __webpack_public_path__ + "img/3-min_Custom.489c704a.jpg";